export { BASE_URL_MAP, API_BASE_URL_MAP } from './baseUrls'
export { LOCAL } from './environments'
export { timeOptions, formatDate } from './times'
export { colors, mainColors } from './colors'
export { timezones } from './timezones'
export { GENDERS } from './genders'
export { EN, RO, LOCALES, DEFAULT_LOCALE } from './locales'

export const untoldEmails = [
  'razvan.marginean@untold.com',
  'lehel.gyorgy@untold.com',
  'stefana.frincu@untold.com',
  'teodora.croitor@untold.com',
  'reci@gmail.com',
  'kinder@gmail.com',
  'ana.caltea@untold.com',
  'sasa@gmail.com',
  'barleamihai@gmail.com',
  'cosmin@gmail.com',
  'teodora.vidrean@untold.com',
]
